import React from 'react';
import styles from './SocialCard.module.css';

const SocialCard = ({
  id = 'social-card',
  title = "Missing Title",
  subtitle,
  width = "1024",
  height = "542",
  description = "Work like a pro React dev",
  website = "profy.dev",
  illustrationUrl
}) => {
  const style = {
    width: parseInt(width),
    height: parseInt(height),
  };
  return (
    <div id={id} className={styles.card} style={style}>
      <div className={styles.content}>
        <div className={styles.contentWrapper}>
          {illustrationUrl && <img className={styles.illustration} src={illustrationUrl} alt="illustration" />}
          <div className={styles.textWrapper}>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
            <h1 className={styles.title}>{title}</h1>
          </div>
        </div>
        <div className={styles.footer}>
          {
            description && description.length > 0 && (
              <>{description} &nbsp;&nbsp;<span className={styles.separator} />&nbsp;&nbsp;&nbsp;</>
            )
          }
          {website}
        </div>
      </div>
    </div>
  );
};

export default SocialCard;
